import React, { useState } from 'react';
import './App.css';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import Travel from './pages/travel';
import RSVP from './pages/rsvp';
import Details from './pages/details';
import Registry from './pages/registry';
import Home from './pages/home';
import Gallery from './pages/gallery';
import hamburger from './hamburger.svg';
import Story from './pages/story';

function App() {

  const navigate = useNavigate();
  const location = useLocation();

  const [isOverlay, setIsOverlay] = useState(false);

  function NavButton(name: string, path: string, imgPath: string = "") {

    const isNavigatedTo = location.pathname === path;

    //TODO: add images as div background to appear on hover
    return (
      <div className={isNavigatedTo ? "Nav-button-selected" : "Nav-button"}
        onClick={() => {
          if (location.pathname !== path) {
            navigate(path)
          }
        }}>
        {name}
      </div>
    )
  }

  function NavHeader() {
    return (
      <div className="Title-banner">
        <span className="Title-banner-text">Nick & Kruthi</span>
        <div className="Nav-header">
          {NavButton("Home", "/", "")}
          {NavButton("Details", "/details", "")}
          {NavButton("Travel", "/travel", "")}
          {NavButton("RSVP", "/rsvp", "")}
          {NavButton("Gallery", "/gallery", "")}
          {NavButton("Our Story", "/story", "")}
          {NavButton("Registry", "/registry", "")}

        </div>
        <Hamburger />
        <DropdownMenu />
      </div>
    )
  }

  function DropdownMenu() {

    const DropdownOption = (name: string, path: string) => {
      return (
        <div className="Nav-dropdown-option"
          onClick={() => {
            if (location.pathname !== path) {
              navigate(path)
              setIsOverlay(false)
            }
          }}
        >{name}</div>
      )
    }

    return (
      <div className={isOverlay ? "Nav-dropdown" : "Nav-dropdown-hidden"}>
        {DropdownOption("Home", "/")}
        {DropdownOption("Details", "/details")}
        {DropdownOption("Travel", "/travel")}
        {DropdownOption("RSVP", "/rsvp")}
        {DropdownOption("Gallery", "/gallery")}
        {DropdownOption("Our Story", "/story")}
        {DropdownOption("Registry", "/registry")}
      </div>
    )
  }

  function Hamburger() {
    const onClick = () => {
      setIsOverlay(!isOverlay)
    }

    return (
      <div className="Nav-dropdown-button" onClick={onClick}>
        <img src={hamburger} className="Hamburger" alt="expand menu" />
      </div>
    )
  }

  return (
    <div className="App">
      {isOverlay ? <div className='Overlay' /> : <></>}
      <NavHeader />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/travel" element={<Travel />} />
        <Route path="/rsvp" element={<RSVP />} />
        <Route path="/details" element={<Details />} />
        <Route path="/registry" element={<Registry />} />
        <Route path="/home" element={<Home />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/story" element={<Story />} />
      </Routes>
    </div>
  );
}

export default App;
